import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/reporting')({
  component: ReportingLayout,
});

function ReportingLayout() {
  return <Outlet />;
}
